import { render } from "./CustomerPrefsPane.vue?vue&type=template&id=6651730e"
import script from "./CustomerPrefsPane.vue?vue&type=script&lang=js"
export * from "./CustomerPrefsPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__